import { autocompleteClasses, AutocompleteRenderGroupParams, ListSubheader } from '@mui/material'
import { ReactNode } from 'react'

type Props = Pick<AutocompleteRenderGroupParams, 'children'> & {
  /** Usually `params.group`, but a consumer may decorate it (e.g. with an option count). */
  label: ReactNode
}

/**
 * The markup MUI's own `renderGroup` produces, for an Autocomplete that needs a custom one — MUI
 * styles its group slots per-instance, so a custom `renderGroup` otherwise loses the themed header.
 */
export const AutocompleteGroup = ({ children, label }: Props) => (
  <li>
    <ListSubheader className={autocompleteClasses.groupLabel} component="div">
      {label}
    </ListSubheader>
    <ul className={autocompleteClasses.groupUl}>{children}</ul>
  </li>
)
